// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_rB","credits":"e_sB","badgeContainer":"e_tB","badge":"e_uB"};